// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"9c5cdcb5","137":"84c091e2","225":"9c5cdcb5","370":"90229940","485":"31d6cfe0","504":"84c091e2","517":"afade49b","731":"4837615d","764":"fcc2e9fa","829":"84c091e2","995":"21161cea"}[chunkId] + ".chunk.css";
};